import { o_global } from "../../browser/head/namespaces.js";
import { assignNamespace } from "../utils/assignNamespace.js";
import { activate, deactivate, logger, updateLogger, warn } from "./debug.js";
import { Level } from "./level.js";
import { status } from "./status.js";

export * from "./debug.js";
export * from "./cookie.js";
export * from "./level.js";
export * from "./status.js";
export * from "./writer.js";
export * from "./async.js";

const debug = {
  /**
 *
 *
 */
  activate,
  /**
 *
 */
  deactivate,
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  logger,
  /**
 *
 */
  Level,
  /**
 *
 */
  status,

  warn,
};

/**
 *
 */
export type GlobalDebug = Omit<typeof debug, "warn">;

/*                            */
updateLogger(status());

/*                                              */
assignNamespace(o_global, "debug", debug);

/*                                                       */
otto.debug.set({
  /*                                                            */
  sendLog: (namespace, data) => window.AS.RUM?.sendCustomRequest(namespace, data),
});
